import Axios from '@/plugins/axios'
import {onlineUrl} from '@/utils/config.js'

// 扣款记录列表气泡
export const getDeductionNum = (params) => {
  return Axios({
    url: onlineUrl + '/purchase-api/supplier/purchase-order/deduction-num',
    method: 'POST',
    data:params
  })
}
// 售后列表气泡（返修/重工/退款）
export const getIssuesListNum = (params) => {
  return Axios({
    url: onlineUrl + '/purchase-api/supplier/purchase-order/es-list/state/num',
    method: 'POST',
    data:params
  })
}